/**
 * Session Manager Plugin - DISABLED
 * Session restoration is now handled directly in middleware
 */

export default defineNuxtPlugin({
  name: "session-manager",
  setup() {
    // No-op - middleware handles session restoration
  },
});
